module.exports = __webpack_public_path__ + "images/paper-add.1790731042052.png";